export class AbstractFilter {
  applyFilterDefinition(filter) {
    this.filter = filter;
    return this;
  }
}
